import { render, staticRenderFns } from "./DealReports.vue?vue&type=template&id=5a58a2e4&"
import script from "./DealReports.vue?vue&type=script&lang=ts&"
export * from "./DealReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports